import { Column } from '@codeparva/ui-components-library';
import React from 'react';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { weakKey } from '../../../../utilities/weakKey';
import { HEADER_ICON_SIZES } from '../Header/constants';
import { useThemeContext } from './hooks/themeContext';
import { useVariant } from './hooks/VariantContext';
import { TopBarTypes } from './topBarTypes';

export const TopBarSocialMediaIcons = (
  contactDetailsforIcons: TopBarTypes.TContactDetailsforIcons
) => {
  const { socialIcons } = contactDetailsforIcons.locations.location;
  const iconsArray: JSX.Element[] = [];
  let currentVariant = useVariant();

  let currTheme = useThemeContext();

  switch (currentVariant) {
    case 'topbar-2':
      currTheme = 'light';
      break;
    case 'topbar-3':
      currTheme = 'dark';
      break;
    default:
      currentVariant = 'topbar-1';
      currTheme = 'light';
  }
  const textColor = currTheme === 'light' ? 'primary' : 'white';
  const renderIconsTopBarHelper = (socialIcons: TopBarTypes.TIconsType[]) => {
    const { show } = contactDetailsforIcons.buttonsConfig;
    if (socialIcons) {
      const iconsData = socialIcons;
      {
        iconsData.forEach((icons: TopBarTypes.TIconsType) => {
          iconsArray.push(
            <a
              href={icons.iconsUrl}
              key={weakKey(icons)}
              target="_blank"
              className={`${show ? 'pr-4' : 'pl-4'} ${currentVariant ===
                'topbar-1' && 'socialIcons'} ${currentVariant === 'topbar-3' &&
                'socialIconsAnchorThree'}`}
            >
              <FontAwesomeIcon
                iconClassName={icons.iconName}
                iconContextProps={{
                  className: `has-text-${textColor}`,
                  style: {
                    fontSize: HEADER_ICON_SIZES.socialiconSize,
                  },
                }}
              />
            </a>
          );
        });
      }
    }
    return iconsArray;
  };

  const renderSwitch = (currentVariant: TopBarTypes.TVariantModes) => {
    switch (currentVariant) {
      case 'topbar-1':
        return (
          <Column renderAs="div" className="topbarCol is-flex">
            {renderIconsTopBarHelper(socialIcons)}
            {contactDetailsforIcons.children}
          </Column>
        );

      case 'topbar-2':
        return <></>;
      case 'topbar-3':
        return (
          <Column renderAs="div" className="topbarCol topbarColSocial3">
            {renderIconsTopBarHelper(socialIcons)}
          </Column>
        );
      case 'topbar-4':
        return <></>;
    }
  };
  return <>{currentVariant && renderSwitch(currentVariant)}</>;
};

export default TopBarSocialMediaIcons;
